import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const imageStackFields = `
  _id,
  _type,
  title,
  items[]{
    title,
    image {
      ${imageFields}
    }
  }
`

export const IMAGE_STACK_QUERY = defineQuery(/* groq */ `
  *[_type == "image-stack"][0]{
    ${imageStackFields}
  }
`)
